import React from "react";
import AuthFooter from "./AuthFooter";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";

function FormWrapper({ children }) {
  const { baseUrl } = React.useContext(AppContext);

  return (
    <div className="col-xl-3">
      <div className="auth-full-page-content p-md-4 p-4">
        <div className="w-100 rigth-inside">
          <div className="d-flex flex-column h-100">
            <div className="my-5 logo-preta">
              <img
                src={`${baseUrl}assets/images/logos/logo_preta.svg`}
                alt=""
              />
            </div>
            <div className="auth-form">{children}</div>
            <AuthFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

FormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormWrapper;
